import React from 'react';
import PropTypes from 'prop-types';

const tooltipBox = {
  border: 'solid silver 1px',
  position: 'fixed',
  backgroundColor: '#93cb68',
  borderRadius: '4px',
  padding: '10px',
  zIndex: 10,
};

const ToolTip = (props) => (
  <div className="tooltip-container">
    <div className="tooltip" style={{ ...tooltipBox, top: props.top, left: props.left }}>
      {props.children}
    </div>
  </div>
);

ToolTip.propTypes = {
  left: PropTypes.string,
  top: PropTypes.string,
  children: PropTypes.node,
};

export default ToolTip;
